import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage';
 

const firebaseConfig = {
    apiKey: "AIzaSyANgfOVcavJBbzlnuI259qfLg6kb22BoYg",
    authDomain: "fellas-bdfb0.firebaseapp.com",
    projectId: "fellas-bdfb0",
    storageBucket: "fellas-bdfb0.appspot.com",
    messagingSenderId: "96751335323",
    appId: "1:96751335323:web:66a9ee847f704adb7f533e"
  };

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const functions = getFunctions(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

